module.exports = __webpack_public_path__ + "static/media/donwloadIcon.bff416e4.svg";